module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/ko_4-08114fe6c6d49d4154566f65cbb42c18.jpg";